import { BaseModel } from "./base-model.interface";
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from "../template/notifications-model.interface";

export interface MainBannerModel extends BaseModel {
  variables?: { [key: string]: string } | MainBannerVariables
}

export interface MainBannerVariables {
  MainBannerImageDesktop: string;
  MainBannerImageMobile: string;
  MainBannerHref: string;
  MainBannerAlt: string;
  MainBannerHrefSegmentRegex: string;
}

export class MainBannerInitVariables implements MainBannerVariables {
  MainBannerImageDesktop = '';
  MainBannerImageMobile = '';
  MainBannerHref = '';
  MainBannerAlt = '';
  MainBannerHrefSegmentRegex = '';
}

export class MainBannerInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MainBannerInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
